/* eslint-disable consistent-return */
import React, { useEffect, useState, useRef } from 'react';
import './SelectOption.scss';
import PropTypes from 'prop-types';

const SelectOption = ({ loading, options, onChange, placeHolder = 'Choose' }) => {
  const [optionPopup, setOptionPopup] = useState(false);
  const [searchValue, setSearchValue] = useState('');
  const [listData, setListData] = useState([]);

  const inputRef = useRef(null);
  const dropdownRef = useRef(null);

  const positionDropdown = () => {
    const input = inputRef.current;
    const dropdown = dropdownRef.current;

    if (input && dropdown) {
      const rect = input.getBoundingClientRect();
      dropdown.style.top = `${rect.bottom + window.scrollY}px`;
      dropdown.style.left = `${rect.left + window.scrollX}px`;
      dropdown.style.width = `${rect.width}px`;
    }
  };

  useEffect(() => {
    if (optionPopup) {
      //   document.body.style.overflow = 'hidden';

      positionDropdown();

      //   window.addEventListener('scroll', positionDropdown, true);
      window.addEventListener('resize', positionDropdown);

      return () => {
        // window.removeEventListener('scroll', positionDropdown, true);
        window.removeEventListener('resize', positionDropdown);
      };
    }
  }, [optionPopup]);

  useEffect(() => {
    setListData(options);
  }, [options]);

  //   useEffect(() => {
  //     if (!optionPopup) {
  //       document.body.style.overflowY = 'auto';
  //     }
  //   }, [optionPopup]);

  const handleChange = (event) => {
    setOptionPopup(true);
    setSearchValue(event.target.value);
    setListData(
      options.filter((item) => {
        return item.label.toLowerCase().includes(event.target.value.toLowerCase());
      }),
    );
  };

  const handleClick = () => {
    setOptionPopup(!optionPopup);
    setSearchValue('');
    setListData(options);
  };

  const handleItem = (val) => {
    onChange(val);
    setSearchValue(val.label);
    setOptionPopup(false);
  };

  return (
    <div className="select-option">
      <div className="option-input">
        <input
          ref={inputRef}
          type="search"
          className="form-control rounded-4"
          placeholder={`${loading ? 'Loading...' : placeHolder}`}
          onChange={(e) => {
            handleChange(e);
          }}
          value={searchValue}
          onClick={handleClick}
        />
      </div>
      {optionPopup && (
        <>
          <div className="select-option-overlay" onClick={handleClick} />
          <div className="select-option-container" ref={dropdownRef}>
            <div className="select-option-popup">
              {loading ? (
                <div className="option-loading">
                  <span>Loading...</span>
                </div>
              ) : listData.length === 0 ? (
                <div className="option-loading">
                  <span>No data</span>
                </div>
              ) : (
                listData.map((item) => (
                  <div className="option-item" key={item.value} onClick={() => handleItem(item)}>
                    <div className="option-item-title">
                      <span>{item.label}</span>
                    </div>
                    <span>{item.info}</span>
                  </div>
                ))
              )}
            </div>
          </div>
        </>
      )}
    </div>
  );
};

SelectOption.propTypes = {
  loading: PropTypes.bool,
  options: PropTypes.array,
  onChange: PropTypes.func,
  placeHolder: PropTypes.string,
};

export default SelectOption;
